import { isRealNumber } from '../../../typescript/guards/isRealNumber'

export type GetShopPagesPriceDisplayReturn = ReturnType<typeof getShopPagesPriceDisplay>

export function getShopPagesPriceDisplay(numericCents: number | undefined | null) {
  return isRealNumber(numericCents) ? `$${(numericCents / 100).toFixed(2)}` : null
}
